import router from "./router";
import store from "./store";
import Vue from "vue";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getRoleId, getStep, getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import { getCurrentExhibitionApi } from "./api/exhibitionList";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();
  const hasStep = getStep();
  console.log("to.path 111====>", to.path, hasStep);
  if (hasToken && hasStep !== "0") {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else if (
      to.path !== "/exhibitionList/exhibitionList" &&
      to.path !== "/intserv/register/index" &&
      to.path !== "/intserv/register/qualification" &&
      to.path !== "/dashboard" &&
      to.path !== "/systemManagement/userManagement" &&
      to.path !== "/home" &&
      to.path !== "/home/index" &&
      to.path !== "/certificateDatabase/personDatabase" &&
      to.path !== "/certificateDatabase/vehicleDatabase"
    ) {
      console.log("to.path====>", to.path);

      // 加一个资质判断，没有资质的用户不允许进入
      if (
        to.path !== "/intserv/register/index" &&
        to.path !== "/intserv/register/qualification" &&
        hasStep !== "3"
      ) {
        console.log("资质校验不通过");
        const roleId = getRoleId();
        if (roleId === "0") {
          Vue.prototype.$message({
            message: "请提交注册资料",
            type: "error",
            duration: 2000,
            offset: 60,
          });
        } else {
          Vue.prototype.$message({
            message: "请等待注册资料审核通过",
            type: "error",
            duration: 2000,
            offset: 60,
          });
        }
        next(false);
        return;
      }

      let res;
      try {
        res = await getCurrentExhibitionApi();
        console.log("getCurrentExhibitionApi---res====>", res);
        if (!res || !res.guid) {
          //如果没有展会信息，提示用户无权限
          Vue.prototype.$message({
            message: "当前没有展会，请先进入展会列表页选择展会!",
            type: "error",
            duration: 1000,
            offset: 60,
          });
          // Message.error("当前没有展会，请先进入展会列表页选择展会!");

          // 阻止路由切换
          next(false);
        } else {
          // 如果有展会信息或不是展会页面，允许路由切换
          // next();
          const hasRoles =
            store.getters.roles && store.getters.roles.length > 0;
          if (hasRoles) {
            next();
          } else {
            try {
              // get user info
              // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
              const { roles } = await store.dispatch("user/getInfo");

              // generate accessible routes map based on roles
              const accessRoutes = await store.dispatch(
                "permission/generateRoutes",
                roles
              );

              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // hack method to ensure that addRoutes is complete
              // set the replace: true, so the navigation will not leave a history record
              next({ ...to, replace: true });
            } catch (error) {
              // remove token and go to login page to re-login
              await store.dispatch("user/resetToken");
              Vue.prototype.$message.error(error || "Has Error");
              next(`/login?redirect=${to.path}`);
              NProgress.done();
            }
          }
        }
      } catch (error) {
        console.error("Error fetching current exhibition:", error);
        Vue.prototype.$message.error("获取展会信息失败，请稍后重试！");
        next(false);
      }
    } else {
      console.log("走资质判断to.path====>", hasStep, to.path);
      // 加一个资质判断，没有资质的用户不允许进入
      if (to.path === "/exhibitionList/exhibitionList" && hasStep !== "3") {
        console.log("资质校验不通过");
        const roleId = getRoleId();
        if (roleId === "0") {
          Vue.prototype.$message({
            message: "请提交注册资料",
            type: "error",
            duration: 2000,
            offset: 60,
          });
        } else {
          Vue.prototype.$message({
            message: "请等待注册资料审核通过",
            type: "error",
            duration: 2000,
            offset: 60,
          });
        }
        next(false);
        return;
      }
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles } = await store.dispatch("user/getInfo");

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch(
            "permission/generateRoutes",
            roles
          );

          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Vue.prototype.$message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
